import React from "react"
import { Github, Linkedin, Mail, ExternalLink, Package } from "lucide-react"

const DevProfile = () => {
  const projects = [
    {
      name: "Rust Blockchain",
      description: "A simple blockchain implementation written in rust",
      link: "https://github.com/mitsuj/rust-blockchain",
      icon: <Package className="w-6 h-6 text-green-500" />,
      tech: ["Rust"],
    },
  ]

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4">
      <div className="max-w-2xl w-full">
        <div
          className="w-32 h-32 rounded-full mx-auto mb-4 border-2 border-gray-400 bg-zinc-900"
          role="presentation"
          aria-hidden="true"
        />
        <h1 className="text-3xl font-semibold text-center mb-2">Sumit Kumar</h1>
        <h2 className="text-2xl text-center text-gray-400 mb-4">
          Blockchain Developer | Protocol Engineer | Rust Expert
        </h2>

        <div className="mb-6">
          <p className="text-lg text-center">
            Passionate about building decentralized systems and advancing
            blockchain technology. Specialized in core protocol development and
            smart contract optimization.
          </p>
        </div>

        <div className="flex justify-center space-x-4 mb-6">
          <a
            href="https://github.com/mitsuj"
            className="text-gray-400 hover:text-white"
          >
            <Github size={24} />
          </a>
          <a
            href="https://linkedin.com/in/smtkr"
            className="text-gray-400 hover:text-white"
          >
            <Linkedin size={24} />
          </a>
          <a
            href="mailto:sumitjcode@gmail.com"
            className="text-gray-400 hover:text-white"
          >
            <Mail size={24} />
          </a>
        </div>

        <div className="space-y-2 mb-6">
          <div className="flex items-center">
            <span className="w-32 font-semibold">Languages:</span>
            <span>Rust, Python, Javascript</span>
          </div>
          <div className="flex items-center">
            <span className="w-32 font-semibold">Frameworks:</span>
            <span>Polkadot-sdk</span>
          </div>
          <div className="flex items-center">
            <span className="w-32 font-semibold">Protocols:</span>
            <span>Polkadot, Solana</span>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-bold mb-4">Projects</h3>
          <div className="space-y-6">
            {projects.map((project, index) => (
              <div key={index} className="bg-zinc-900 p-4 rounded-lg">
                <div className="flex items-center mb-2">
                  {project.icon}
                  <h4 className="text-lg font-semibold ml-2">{project.name}</h4>
                </div>
                <p className="text-lg text-gray-400 mb-3">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-3">
                  {project.tech.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="text-xs bg-zinc-800 text-gray-300 px-2 py-1 rounded"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <a
                  href={project.link}
                  className="text-blue-400 hover:text-blue-300 inline-flex items-center text-sm"
                >
                  View Project <ExternalLink size={14} className="ml-1" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DevProfile
